import { JSX, forwardRef, memo } from "react";
import { Link } from "react-router-dom";

import { Notification } from "@/api/user/user.types.ts";
import { ROUTES } from "@/config/routes.ts";
import { cn } from "@/utils/cn.ts";

const NotificationCard = forwardRef<HTMLAnchorElement, Notification>(
  ({ description, date_created, id, is_read, picture, title }, ref): JSX.Element => {
    const date = new Date(date_created);

    const formattedDate = date.toLocaleDateString("ru", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    return (
      <Link
        ref={ref}
        to={ROUTES.NOTIFICATIONS.SINGLE.replace(":id", id.toString())}
        aria-label={title}
        className={cn("flex w-full flex-row items-start gap-5", "max-md:flex-col max-md:items-stretch max-md:gap-4")}
      >
        <img
          src={picture.resized}
          alt={title}
          loading={"lazy"}
          className={
            "aspect-[325/183] w-80 rounded-5 bg-surface-container object-cover object-center max-md:w-full max-md:rounded-3xl"
          }
        />
        <div className={"max-w-[34.875rem] space-y-[0.938rem] max-md:space-y-2"}>
          <p
            className={cn(
              "relative pl-4 text-sm/4 font-medium",
              "before:absolute before:left-0 before:top-1/2 before:size-1.5 before:-translate-y-1/2 before:transform before:rounded-full before:bg-orange-1 before:content-['']",
              {
                "before:bg-grey-1": is_read,
              },
            )}
          >
            {formattedDate}
          </p>
          <h3 className={"line-clamp-2 text-2xl/tight font-semibold max-md:h-12 max-md:text-xl/6"}>{title}</h3>
          <p className={"line-clamp-3 text-grey-1"}>{description}</p>
        </div>
      </Link>
    );
  },
);

NotificationCard.displayName = "NotificationCard";

export default memo(NotificationCard);
